import { useState, useEffect } from 'react';
import { UtensilsCrossed, Loader2 } from 'lucide-react';
import { getMenu } from '../lib/api';

export const MenuPage = () => {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedImage, setSelectedImage] = useState(null);

  useEffect(() => {
    const fetchMenu = async () => {
      try {
        const response = await getMenu();
        setImages(response.data);
      } catch (error) {
        console.error('Error fetching menu:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchMenu();
  }, []);

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="menu-loading">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  }

  return (
    <div className="py-8 px-4" data-testid="menu-page">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold/10 border border-gold/20 rounded-full mb-4">
            <UtensilsCrossed className="w-4 h-4 text-gold" />
            <span className="text-sm font-semibold text-gold uppercase tracking-wider">
              Cucina del Torneo
            </span>
          </div>
          <h1 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter">
            IL NOSTRO <span className="text-gold">MENU</span>
          </h1>
          <p className="mt-3 text-slate-400">
            Specialità della casa per accompagnare le serate del torneo
          </p>
        </div>

        {/* Menu Images */}
        {images.length > 0 ? (
          <div className="grid gap-6 md:grid-cols-2">
            {images.map(image => (
              <div
                key={image.id}
                className="glass-card overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform"
                onClick={() => setSelectedImage(image)}
                data-testid={`menu-image-${image.id}`}
              >
                <img
                  src={`data:${image.content_type};base64,${image.data}`}
                  alt={image.filename}
                  className="w-full h-auto"
                />
              </div>
            ))}
          </div>
        ) : (
          <div className="glass-card p-12 text-center">
            <UtensilsCrossed className="w-16 h-16 text-slate-600 mx-auto mb-4" />
            <h3 className="font-heading text-xl font-bold mb-2">Menu non ancora disponibile</h3>
            <p className="text-slate-400">
              Il menu verrà pubblicato a breve
            </p>
          </div>
        )}

        {/* Lightbox */}
        {selectedImage && (
          <div 
            className="fixed inset-0 z-50 bg-black/90 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <img
              src={`data:${selectedImage.content_type};base64,${selectedImage.data}`}
              alt={selectedImage.filename}
              className="max-w-full max-h-full object-contain"
            />
            <button
              className="absolute top-4 right-4 text-white text-4xl hover:text-primary transition-colors"
              onClick={() => setSelectedImage(null)}
            >
              ×
            </button>
          </div>
        )}

        {/* Info Box */}
        <div className="mt-12 glass-card p-6 text-center">
          <img 
            src="https://images.pexels.com/photos/29369878/pexels-photo-29369878.jpeg" 
            alt="Cucina" 
            className="w-full h-48 object-cover rounded-lg mb-4"
          />
          <h3 className="font-heading text-xl font-bold mb-2">CUCINA APERTA TUTTE LE SERE</h3>
          <p className="text-slate-400">
            Durante le partite potrai gustare i piatti della nostra cucina.
            <br />
            Vieni a tifare e a mangiare con noi!
          </p>
        </div>
      </div>
    </div>
  );
};

export default MenuPage;
